module.exports = __webpack_public_path__ + "media/honey-icons/icon-thermostat-gen-1-aa89877d.svg";